exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-study__shopsquare{font-size:30px}.case-study__shopsquare .case-study__photo-background{background-color:#e3f0ff}.case-study__shopsquare .case-study__photo{margin-top:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-13c84e44!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/CaseStudy/Shopsquare.vue
// module id = 111
// module chunks = 0